export default () => {
  // Remove class on all route changes, also between different layouts
  document.body.classList.remove('mobile-nav-open')
}
